import { Utils } from "@/plugins/utils";
import moment from "moment"

export default {
    namespaced: true,
    state: {
        mb2: {},
        lstMb2: [],
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
        sinceDate: moment().subtract(1, 'month').format("YYYY-MM-DD 00:00"),
        untilDate: moment().format("YYYY-MM-DD 23:59"),
        mb2sitconChip: [0, 1],
        mb3tipoChip: [0, 1],
    },
    getters:{
        getMb2:(state) => state.mb2,
        getUpdate:(state) => state.update,
        getItemsPerPage:(state) => state.itemsPerPage,
        getSearch(state) {
            return state.search || "";
        },
        getFn3(state, getters, rootState, rootGetters) {
            return rootGetters['fn3/getFn3']
        }
    },
    mutations: {
        setLstMb2(state, lstMb2) {
            state.lstMb2 = lstMb2
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setParamsDataTable(state, payload) {
            state.lstMb2 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
    },
    actions: {
        async search({ commit, dispatch, state, getters }, { limit = 20, page = 1 }) {
            commit("setLoading", true);

            let fn3 = getters.getFn3
            
            if(state.mb2sitconChip.length == 0) {
                state.mb2sitconChip = [0, 1]
            }
            if(state.mb3tipoChip.length == 0) {
                state.mb3tipoChip = [0, 1]
            }

            let urlMb2sitconChip = ""
            for (const status of state.mb2sitconChip) {
                urlMb2sitconChip += `&statusMb2sitcon=${status}`
            }
            let urlMb3tipoChip = ""
            for (const status of state.mb3tipoChip) {
                urlMb3tipoChip += `&statusMb3tipo=${status}`
            }

            let payload = await this._vm.$axios.get(
                `/Financial/BankTransactionItems/Search?` +
                `search=${getters.getSearch}` +
                `&bankingAgent=${fn3.fn3agente}` +
                `&sinceDate=${state.sinceDate}` +
                `&untilDate=${state.untilDate}` +
                `&limit=${limit}` +
                `&page=${page}` +
                urlMb2sitconChip +
                urlMb3tipoChip
            )
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                commit("setParamsDataTable", payload);
                return true;
            })
            .catch((error) => {
                commit("setLstMb2", []);
                dispatch("parameters/openDialog", {
                titleText: "Erro",
                titleColor: "red",
                text: error.message
                }, { root: true });
                return false;
            });

            commit("setLoading", false);

            return payload;
        },
    }
}